module.exports = __webpack_public_path__ + "static/images/callout_3.86dcb76e519d46af54384c904078a3fb.jpg";